import { DETERMINAR_PAGINA_ATUAL_MAPAS_VEICULOS } from '../types'

export default function determinarPaginaAtualMapasVeiculos (paginaAtual) {
  return {
    type: DETERMINAR_PAGINA_ATUAL_MAPAS_VEICULOS,
    payload: paginaAtual
  }
}
